import React, { ReactElement } from 'react'
import { Alert, Box } from '@ally/metronome-ui'

export default (): ReactElement => {
  return (
    <Box mb="sm">
      <Alert
        variant="error"
        heading="We can't show your Wealth Overview right now."
        body="We're working to have things back up as soon as possible. Try again later."
      />
    </Box>
  )
}
